export default __webpack_public_path__ + "static/media/frutos-secos.2e6f2c97.svg";